import { Navigate } from "react-router-dom";

import PrivateLayout from "../layouts/private/Private";
import useCheckAuthStatus from "../providers/useCheckAuthStatus";

const PrivateRoute = (props) => {
	const { component: Component } = props;
	const isLoggedIn = localStorage.getItem("token");

	useCheckAuthStatus();

	if (isLoggedIn) {
		return (
			<PrivateLayout {...props}>
				<Component {...props} />
			</PrivateLayout>
		);
	}

	return <Navigate to="/" replace />;
};

export default PrivateRoute;
